// JOBE-0122: per-kind row-renderer registry for the EntityBrowser list
// column. Mirrors the inspector preview registry pattern (one source of
// truth, single-line registration per kind). Consumed by
// `<LibraryListBody>` / `<LibraryTable>` — when a registered kind row
// is rendered, the registered component takes over; otherwise the
// default `<LibraryRow>` continues to render.
//
// Adding a new per-kind row is a two-line change: add the component
// file, add the registry entry below.

const registry = new Map();

// pickRow returns the per-kind row component for `entity`, or `null` to
// signal the default `<LibraryRow>` fallback.
export function pickRow(entity) {
  if (!entity || !entity.kind) return null;
  if (registry.has(entity.kind)) return registry.get(entity.kind);
  return null;
}
